
export const colors = {
    primary: "#2A4365", // Deeper, more professional blue
    primaryHighlighted: "#1A365D", // Darker shade for emphasis
    SideBarSelected: "#4C6690", // Sophisticated navy

    secondary: "#FFFFFF",
    secondaryHighlighted: "#EDF2F7", // Softer highlight

    disabled: "#E2E8F0",
    disabledHighlighted: "#A0AEC0",

    error: "#E53E3E", // More assertive red

    white: "#FFFFFF",

    text: "#2D3748", // Darker, more readable text

    positive: "#38A169", // Fresh green
    negative: "#C53030", // Strong red

    transparent: "transparent",

    winter: "#718096", // Warmer gray

    doughnutChartColorScale: ["#2C5282", "#B7791F", "#4C51BF", "#C05621", "#C53030", "#5A67D8", "#319795", "#2B6CB0", "#4A5568", "#805AD5"],

    darkRed: "#9B2C2C",

}